(function(){
	'use strict';
	jQuery(document).ready(function($) {
		$("body").on('click', '.catalog-swatch-item a', function(event) {
			event.preventDefault();
			/* Act on the event */
		var thumb = $(this).data('thumb');
		$(this).closest('div.item-wrap').find('img.product-image').attr('src',thumb);
		});
		$(document).on('click', '.wishlist-login', function(event) {
			event.preventDefault();
			/* Act on the event */
			swal({
				title: 'You are not login?',
				text: "Please login to use wishlist!",
				type: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Login now',
				cancelButtonText: 'No, Close me!',
				confirmButtonClass: 'btn btn-success',
				cancelButtonClass: 'btn btn-default',
				buttonsStyling: false
			}).then(function(isConfirm) {
				if (isConfirm === true) {
					window.location.href = '/account/login';
				} else if (isConfirm === false) {
					swal({
						showConfirmButton: false,
						"title": "Cancelled",
						"type": "error",
						timer: 2000,
					});
				} else {
					// Esc, close button or outside click
					// isConfirm is undefined
				}
			})
		});
		$(document).on('click', ".add_to_wishlist_btn", function(event) {
			var $this = $(this);
			event.preventDefault();
			/* Act on the event */
			var myid = $(this).data('form');
			var args = $("input[value='" + myid + "']").first().parent('form').serialize();
			$("#loading").show();
			$.ajax({
				url: '/contact',
				type: 'POST',
				dataType: 'html',
				data: args,
				success: function(data, status) {
					if (status == "success") {
						$('[data-form="' + myid + '"]').hide(600).next('a.added-wishlist').css({
							visibility: 'visible',
							display: 'inline-block'
						});
						$("#loading").hide(500);
						swal({
							title: "Good job!",
							text: "Added success to wishlist!",
							timer: 2000,
							type: "success",
							showConfirmButton: false
						});
					} else {
						$("#loading").hide(500);
						sweetAlert({
							type: "error",
							title: "Opps",
							text: "Please <a class='alert-bold' href='/account/login'>login</a> to use wishlist!",
							html: true
						});
					}
				}
			});
		});
		$(document).on('click', '.delete-wishlist', function(event) {
			event.preventDefault();
			/* Act on the event */
			$("#loading-ajax").show();
			/* Remove product from wishlist*/
			var $this = $(this); 
			var value = $(this).data('wid');
			$('.remove-value').val(value);
			var args = $('.contact-form').serialize();
			$.ajax({
				url: $('.contact-form').attr('action'),
				type: 'POST',
				dataType: 'html',
				data: args,
				success: function(data, status) {
					if (status == "success") {
						$("#wishlist-kt-" + value).slideUp(600).remove();
						$("#loading-ajax").hide(500);
						swal({
							title: "Good job!",
							text: "Remove success.",
							timer: 2000,
							type: "success",
							showConfirmButton: false
						});
					} else {
						$("#loading-ajax").hide(500);
					}
				}
			});
		});
		$(document).on('click', '.swatch-color', function(event) {
			event.preventDefault();
			/* Act on the event */
			var $val = $(this).data("value");
			var $id = $(this).data('id');
			$('.swatch-color').removeClass('selected');
			$(this).addClass('selected');
			var $thumb = $(this).data('thumb');
			$($id).val($val).attr('value',$val).trigger('change');
			$("#carousel-example-generic .carousel-indicators, #carousel-example-generic .carousel-inner").children('div').removeClass('active').first().addClass('active');
			$(".carousel-inner div.item.active").attr('href',$thumb).find('img').attr('src',$thumb);
          $(".carousel-indicators li").removeClass('active').first().addClass('active');
		});
		$(document).on('click', '.swatch-size', function(event) {
			event.preventDefault();
			/* Act on the event */
			var $val = $(this).data("value");
			var $id = $(this).data('id');
			$('.swatch-size').removeClass('selected');
			$($id).val($val).attr('value',$val).trigger('change');
			$(this).addClass('selected');
		});
		$(document).on('click', '.swatch-color-single', function(event) {
			event.preventDefault();
			/* Act on the event */
			var $val = $(this).data("value");
			var $id = $(this).data('id');
			$('.swatch-color-single').removeClass('selected');
			var $thumb = $(this).data('thumb');
			$(this).addClass('selected');
			$($id).val($val).attr('value',$val).trigger('change');
			$(".main-image").find('a').attr('href',$thumb).children('img').attr('src',$thumb).attr('data-large',$thumb);
			 $(".my-foto").imagezoomsl({magnifiersize:[300,550]});

		});
		var freewall_element =$("#freewall");
		$('body').on('click','.ldraggable',function(){
                var url = $(this).find('a').attr('href');
                window.location = url;
            });
		if ($("#freewall").length > 0) {
			var wall = new freewall("#freewall");
            freewall_element.find('div.cell').each(function(index, el) {
            	var cellW = $(this).attr('data-cellW') ;
	            var cellH = $(this).attr('data-cellH');
	            if($(window).width() < cellW)
	            {
	                cellW = $(window).width();
	            }
	            wall.reset({
	                selector: '.cell',
	                animate: true,
	                cellW: cellW,
	                cellH: cellH,
	                gutterX: 30, // width spacing between blocks;
	                gutterY: 30,
	                onResize: function() {
	                    wall.fitWidth();
	                },
	                onBlockFinish: function(item,block,setting){
                  console.log(item);
	                    var nWidth = item.width;
	                    var Width = $(this).attr('data-cellw');

	                    var nHeight = item.height;
	                    var Height = $(this).attr('data-cellh');
	                    var i = 0;

	                    $(this).find('.ldraggable').each(function(){
	                        var oleft = $(this).attr('data-left');
	                        var top = $(this).attr('data-top');
	                        var tmp = parseFloat(nWidth)/parseFloat(Width);
	                        var left = parseFloat(oleft)*tmp;

	                        $(this).css('left',left+'px');
	                        var tmp = nHeight / Height;
	                        var top = parseFloat(top)*tmp + i*40;
	                        $(this).css('top',top+'px');
	                        i++;
	                    })



	                } 
	            });
	            wall.fitWidth();
            });
		}
	var 	isMobile=  function() {
				var isMobile = false; //initiate as false
				// device detection
				if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) isMobile = true;

				return isMobile;
			}
		var do_not_show = false;
		if (typeof(Storage) !== "undefined") {
		    // Code for localStorage/sessionStorage.
		    $(document).on('change', ".yith-popup-checkbox", function(event) {
		    	event.preventDefault();
		    	/* Act on the event */
		    	localStorage.setItem("newsletter", !$(this).prop('checked'));
		    });
		  do_not_show =  localStorage.getItem("newsletter");
		  if( do_not_show == null ||  typeof do_not_show == 'undefined'){localStorage.setItem("newsletter", true); do_not_show = true}
		} else {
		    // Sorry! No Web Storage support..
		}
 
		if (newlestter_enable == true  && (do_not_show == 'true' || do_not_show == true ) && isMobile() == false ) {

			var b = $(".ypop-container").find("form");
				$("body").yit_popup({
					content: $(".ypop-container").html(),
					delay: 0,
					position: "center",
					mobile: ypop_frontend_var.ismobile
				});
				$("body").on("close.ypop", function() {
					$("input.no-view").is(":checked") ? $.cookie(ypop_frontend_var.never_show_again_cookie_name, "1", {
						expires: parseInt(ypop_frontend_var.expired),
						path: "/"
					}) : $.cookie(ypop_frontend_var.show_next_time_cookie_name, "1", {
						path: "/"
					})
				});
				if (b.length) b.on("submit", function(b) {
					$.cookie(ypop_frontend_var.never_show_again_cookie_name,
						"1", {
							expires: parseInt(ypop_frontend_var.expired),
							path: "/"
						})
				})
		}
	});
	$(window).ready(function() {
			if ($('#magazine').length > 0) {
				$('#magazine').turn({
	                display: 'double', 
	                acceleration: true,
	                gradients: !$.isTouch,
	                elevation:50,
	                page:1,
	                when: {
	                    turned: function(e, page) {
	                        /*console.log('Current view: ', $(this).turn('view'));*/
	                    }
	                }
	            });
			}
        });
        $(window).bind('keydown', function(e){
            if (e.keyCode==37)
                $('#magazine').turn('previous');
            else if (e.keyCode==39)
                $('#magazine').turn('next');
        });
        $(window).load(function() {
            $('.flexslider').flexslider({
                animation: 'fade',
                direction: 'horizontal',
                prevText: "",
                nextText: "",
                slideshowSpeed: 5000,
                animationSpeed: 300,
                animationLoop: true,
                itemMargin: 0,
                itemWidth: 1024,
                start:function(){
                    $('ul.slides').find('li').each(function(){
                        var nWidth = $(this).width();
                        var Width = $(this).attr('data-cellw');

                        var nHeight = $(this).height();
                        var Height = $(this).attr('data-cellh');

                        var i = 0;
                        $(this).find('.ldraggable').each(function(){
                            var oleft = $(this).attr('data-left');
                            var top = $(this).attr('data-top');
                            var tmp = parseFloat(nWidth)/parseFloat(Width);
                            var left = parseFloat(oleft)*tmp ;

                            $(this).css('left',left+'px');
                            var tmp = nHeight / Height;
                            var top = parseFloat(top)*tmp ;
                            $(this).css('top',top+'px');
                            i++;
                        });
                    });
                }
            });
        });
})(jQuery);
